import { Injectable } from '@angular/core';
import {
  LegalTermPreviewAdapter,
} from '@sbd-doug-frontend/shared/lib/shared-components/legal-term-previewer/legal-term-previewer.adapter';
import {
  LegalTermPreviewLayout,
} from '@sbd-doug-frontend/shared/lib/shared-components/legal-term-previewer/legal-term-previewer.component';
import { LegalTerm } from '@sbd-account-portal/app/modules/terms-review/legal-term.type';

@Injectable({ providedIn: 'root' })
export class AccountPortalLegalTermPreviewAdapter implements LegalTermPreviewAdapter<LegalTerm> {
  private toBool(v: any): boolean {
    if (v === true) return true;
    if (v === false) return false;
    if (typeof v === 'string') {
      const s = v.trim().toLowerCase();
      if (s === 'true' || s === '1' || s === 'yes') return true;
      if (s === 'false' || s === '0' || s === 'no') return false;
    }
    if (typeof v === 'number') return v === 1;
    return !!v;
  }

  getTitle(term: LegalTerm): string {
    return term?.label;
  }

  getHtml(term: LegalTerm): string | null {
    return term?.body_html ?? null;
  }


  getStatusLabel(term: LegalTerm): string | null {
    return 'Active';
  }

  getVersion(term: LegalTerm): string | null {
    return null;
  }

  getEffectiveAt(term: LegalTerm): string | null {
    return null;
  }

  getExpiresAt(term: LegalTerm): string | null {
    return null;
  }

  getCheckboxLabel(term: LegalTerm): string | null {
    return term?.checkbox_label ?? null;
  }

  getCtaLabel(term: LegalTerm): string | null {
    return term?.button_label ?? null;
  }

  getLockSystem(term: LegalTerm): boolean | null {
    const v = term?.lock_system;
    return v === undefined || v === null ? null : this.toBool(v);
  }

  getLayout?(term: LegalTerm): LegalTermPreviewLayout | null {
    return term?.layout || 'page';
  }

  getDeadline(term: LegalTerm): string {
    return term?.legal_term_deadline ?? null as any;
  }

  getDeadlineExceeded(term: LegalTerm): boolean | null {
    const v = term?.deadline_exceeded;
    return v === undefined ? null : !!v;
  }

  getRemoveReminderButton(term: LegalTerm): boolean | null {
    const v = term?.remove_reminder_button;
    return v === undefined || v === null ? null : !!v;
  }
}
